import React from "react"
import { Roles } from "app/models/user"
import useAccessRoles from "./useAccessRoles"

type Props = {
  allowedRoles?: Roles[]
  children: React.ReactNode
}

const AccessRoles = React.forwardRef<HTMLDivElement, Props>(
  ({ allowedRoles, children }, ref): JSX.Element | null => {
    const { isAllowed } = useAccessRoles(allowedRoles)

    return isAllowed ? <div ref={ref}>{children}</div> : null
  },
)

export default AccessRoles
